<h1 mat-dialog-title>Pago realizado con éxito</h1>
<div mat-dialog-content>Su publicación estará activa por X dias.</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close color="primary" (click)="close()">continuar</button>
</div>